module.exports = __webpack_public_path__ + "static/media/Super.0f2bfdba.png";